export const AUDIO_DOWNLOAD_TYPE = 'AUDIO_DOWNLOAD_TYPE';
export const BACKEND = 'BACKEND';

export class LocalStorageService {
  // constructor() {
  // }

  getItem(key, def) {
    if (!localStorage) return null;
    const value = localStorage.getItem(key);
    return value === null || value === 'null' ? (def || value) : value;
  }

  setItem(key, value) {
    return localStorage && localStorage.setItem(key, value);
  }

  removeItem(key) {
    return localStorage && localStorage.removeItem(key);
  }

  hasItem(key) {
    return this.getItem(key) !== null;
  }

  isTrue(key) {
    return localStorage && localStorage.getItem(key) && localStorage.getItem(key).toLowerCase() === 'true';
  }

  getTableSettings() {
    return JSON.parse(this.getItem('tableSettings', '{}'));
  }

  getTableSetting(key) {
    const settings = this.getTableSettings();
    return settings[key];
  }

  setTableSetting(key, setting) {
    const settings = this.getTableSettings();
    settings[key] = setting;
    this.setItem('tableSettings', JSON.stringify(settings));
  }

  removeTableSetting(key) {
    const settings = this.getTableSettings();
    delete settings[key];
    this.setItem('tableSettings', JSON.stringify(settings));
    return settings;
  }


  copyTextToClipboard(text) {
    const copyTextToClipboardChrome = text => {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
      } catch (err) {
        console.error('unable copy to clipboard', err);
      }
      document.body.removeChild(textArea);
    };


    if (!navigator.hasOwnProperty('clipboard')) {
      copyTextToClipboardChrome(text);
      return;
    }
    navigator.clipboard.writeText(text).then(() => {}, err => {
      console.error('unable copy to clipboard', err);
    });
  }

}



// WEBPACK FOOTER //
// ./src/core/local-storage.service.js